<rr-start-logo class="logo" color="inverse" routerLink="/"></rr-start-logo>
<div class="card col">
    <img src="/images/congrat-signup.png" alt="" />
    <h1 i18n>You're almost there!</h1>
    <div>
        We've sent a confirmation link to your email. Just click it to reset
        your password — it only takes a second.
    </div>
</div>
